module.exports = __webpack_public_path__ + "static/media/weight-graph-small.153faa4d.mp4";